import { useSnapshot } from "valtio"
import { chargesBookingValidationStore } from "../mybooksv3/booking-commonstate.js"
import { AgmodalStore, cargoStore, configStore, contractsStore } from "../state/CommonState.js";
import { useEffect, useMemo, useState } from "react";
import { loadAiHistory, getAiHistory } from "../components/AiChargeParse.js";
import Utils from "../util/Utils.js";
import { Card } from "../v3-componets/AgCard.js"
import { Headspan } from "../v3-componets/AgHeadspan.js"
import { chargesData1 } from "../StaticData.js";
import QuoteCalcV2 from "../util/quote-calc-v2.js";
import { loader } from "../util/loader.js";
import Api from "../state/Api.js";
import { editapprovalStore } from "./editapprovalStore.js";
import RoleUtils from "../util/RoleUtils.js";
import { PERMISSIONS_NEW } from "../util/constants.js";
import TenantUtils from "../util/tenant.utils.js";
import { LCLChargesCompFrom } from "../quick-quotev3/editchargenew.js";
import { FormProvider, useForm, useWatch } from "react-hook-form";

export default function EditApproveCharge(props) {
    let setOpenChargeModel = props.setOpenChargeModel
    useSnapshot(contractsStore)
    useSnapshot(editapprovalStore)
    // AI charge history of this quotation: loaded per quote #, saved with the approval (save below)
    const aiHistoryKey = editapprovalStore.quote?._id || ""
    useEffect(() => { loadAiHistory("quoteApproval", aiHistoryKey, editapprovalStore.quote?.quoteData?.aiChargeHistory) }, [aiHistoryKey])
    const [originallist,setOriginallist] = useState([])
    const [originalrebatelist,setOriginalrebatelist] = useState([])
    const [originalpkblist,setOriginalpkblist] = useState([])
    const [tlimits,setTlimits] = useState([])
    const [errors,setErrors] = useState([])
    const [show, setShow] = useState(false)
    const [show1, setShow1] = useState(false)
    const [actionmodal, setActionmodal] = useState(false)
    const [conditions,setConditions] = useState([])
    const [remarks,setRemarks] = useState("")
    const charges = useForm({
        defaultValues:{
            groupedByCategory:{},
            rebate:[],
            pkb:[],
            list:[],
            originallistlist:[],
            originallistrebate:[],
            originallistpkb:[],
            initialLength:0
        }
    })
    const { control, setValue } = charges;
        
    const watchedList = useWatch({
        control,
        name: 'list',
    });

    const watchedRebate = useWatch({
        control,
        name: 'rebate',
    });

    const watchedPkb = useWatch({
        control,
        name: 'pkb',
    });

    const req = useMemo(() => {
          let limits = []
          let lobj = {}
          let eobj = {}
          let err = []
          if(editapprovalStore.quote!=undefined && watchedList!=undefined && watchedPkb!=undefined && watchedRebate!=undefined){
            let l = JSON.parse(JSON.stringify(editapprovalStore.quote?.quoteData))
            l['orginalchargesList'] = []
            l['chargesList'] = []
            l['shipperchargesList'] = []
            l['consigneechargesList'] = []
            l['pkb'] = []
            l['rebate'] = []
            if(watchedList.length>0){
                l['orginalchargesList'] = JSON.parse(JSON.stringify(watchedList))
            }
            if(watchedPkb.length>0 && watchedPkb[0]["total"]!=undefined && watchedPkb[0]['total']!=0){
                l['pkb'] = JSON.parse(JSON.stringify(watchedPkb))
                l['pkb'][0]['id'] = 1
                l['pkb'][0]['isIncluded'] = 'Yes'
            }
            if(watchedRebate.length>0 && watchedRebate[0]["total"]!=undefined && watchedRebate[0]['total']!=0){
                l['rebate'] = JSON.parse(JSON.stringify(watchedRebate))
                l['rebate'][0]['id'] = 1
                l['rebate'][0]['isIncluded'] = 'Yes'
            }
            let z = l['orginalchargesList']
            for (let i = 0; i < z.length; i++) {
                z[i]['id'] = i+1
                if(z[i]['total']!=0){
                    z[i]['isIncluded'] = 'Yes'
                    if(z[i]['onaccount']=='On Your Account'){
                        l['chargesList'].push(z[i])
                    } 
                    if(z[i]['onaccount']=="Shipper's Account"){
                        l['shipperchargesList'].push(z[i])
                    }
                    if(z[i]['onaccount']=="Consignee's Account"){
                        l['consigneechargesList'].push(z[i])
                    }
                }
            }
            l['orginalchargesList'] = z
            let k = new QuoteCalcV2(l).recalc()
            l['quoteValue'] = k.quoteValue
            l['quoteValueUSD'] = k.quoteValueUSD
            if(k.quoteValue!=0){
                let t1 = Utils.getTotal(originallist)+Utils.getTotal(originalrebatelist)+Utils.getTotal(originalpkblist)
                let t2 = Utils.getTotal(l['orginalchargesList'])
                let t3 = Utils.getTotal(l['pkb'])
                let t4 = Utils.getTotal(l['rebate'])
                t2 = t2+t4+t3
                conditions.map(e=>{
                    if(e.reductionPercentage!=undefined){
                        if(((t2 / t1) * 100) < (100 - e.reductionPercentage)){
                            if(lobj[JSON.stringify(e)]==undefined){
                            lobj[JSON.stringify(e)] = 1
                            limits.push(e)
                            }
                            let e2 = `Charge list total: ${t1.toFixed(2)} (100.00%), Revised list total: ${t2.toFixed(2)} (${((t2 / t1) * 100).toFixed(2)}%) is less than the allowed limit (${(100 - e.reductionPercentage).toFixed(2)}%).`
                            if(eobj[JSON.stringify(e2)]==undefined){
                            eobj[JSON.stringify(e2)] = 1
                            err.push(e2)
                            }
                        }
                    }
                    if(e.reductionValue!=undefined){
                        let v = configStore.getExchangeRate(e.reductionValueCurrency)
                        let t5 = t1/v
                        let t6 = t2/v
                        let t7 = t5-e.reductionValue
                        if(t7>t6){
                            let e2 = `Charge list total: ${Utils.N(t5,e.reductionValueCurrency)} (100.00%), Revised list total: ${Utils.N(t6,e.reductionValueCurrency)} (${((t2 / t1) * 100).toFixed(2)}%) is less than the allowed limit (${Utils.N(t7,e.reductionValueCurrency)}%).`
                            if(lobj[JSON.stringify(e)]==undefined){
                                lobj[JSON.stringify(e)] = 1
                                limits.push(e)
                            }
                            if(eobj[JSON.stringify(e2)]==undefined){
                                eobj[JSON.stringify(e2)] = 1
                                err.push(e2)
                            }
                        }
                        // l['orginalchargesList'].map(e1=>{
                        //     if(e1['currency']==e.reductionValueCurrency){
                        //         if(e1['total']<e.reductionValue){
                        //             if(lobj[JSON.stringify(e)]==undefined){
                        //             lobj[JSON.stringify(e)] = 1
                        //             limits.push(e)
                        //             }
                        //             let e2 = `${e1['chargeDescription']}, Currency: ${e.reductionValueCurrency}, Totol: ${e1['total']} is less than the allowed limit ${e.reductionValue}`
                        //             if(eobj[JSON.stringify(e2)]==undefined){
                        //             eobj[JSON.stringify(e2)] = 1
                        //             err.push(e2)
                        //             }
                        //         }
                        //     }
                        // })
                    }
                })
                if(err.length==0 && t1!=t2 && conditions.length==0){
                    err.push(`Charge list total: ${t1.toFixed(2)} (100.00%), Revised list total: ${t2.toFixed(2)} (${((t2 / t1) * 100).toFixed(2)}%).`)
                }
            }
          }
          return { limits, err };
        }, [watchedList,watchedPkb,watchedRebate,conditions,originallist]);

    useEffect(()=>{
        if(editapprovalStore.quote?.quoteData && JSON.stringify(contractsStore.current)!=JSON.stringify(editapprovalStore.quote?.quoteData)){
            contractsStore.current = JSON.parse(JSON.stringify(editapprovalStore.quote?.quoteData))
        }
    },[JSON.stringify(editapprovalStore.quote)])

    const save = ()=>{
        let limits = []
        let lobj = {}
        let eobj = {}
        let err = []
        if(editapprovalStore.quote!=undefined && watchedList!=undefined && watchedPkb!=undefined && watchedRebate!=undefined){
            let l = JSON.parse(JSON.stringify(editapprovalStore.quote?.quoteData))
            chargesBookingValidationStore.isNew = false
            let kz = true
            if (watchedList &&
            !watchedList.every((charge, index) =>
                Object.keys(charge).every((chargeKey) =>
                chargesBookingValidationStore.isValidChargelclform(chargeKey, index,watchedList)
                )
            )
            ) {
            kz = false
            }
            if(!kz){
                configStore.setModalMessage(`Please check the charges detail fields`);
                return false;
            }
            l['orginalchargesList'] = []
            l['chargesList'] = []
            l['shipperchargesList'] = []
            l['consigneechargesList'] = []
            l['pkb'] = []
            l['rebate'] = []
            if(watchedList.length>0){
                l['orginalchargesList'] = JSON.parse(JSON.stringify(watchedList))
            }
            if(watchedPkb.length>0 && watchedPkb[0]["total"]!=undefined && watchedPkb[0]['total']!=0){
                l['pkb'] = JSON.parse(JSON.stringify(watchedPkb))
                l['pkb'][0]['id'] = 1
                l['pkb'][0]['isIncluded'] = 'Yes'
            }
            if(watchedRebate.length>0 && watchedRebate[0]["total"]!=undefined && watchedRebate[0]['total']!=0){
                l['rebate'] = JSON.parse(JSON.stringify(watchedRebate))
                l['rebate'][0]['id'] = 1
                l['rebate'][0]['isIncluded'] = 'Yes'
            }
            let z = l['orginalchargesList']
            for (let i = 0; i < z.length; i++) {
                z[i]['id'] = i+1
                if(z[i]['total']!=0){
                    z[i]['isIncluded'] = 'Yes'
                    if(z[i]['onaccount']=='On Your Account'){
                        l['chargesList'].push(z[i])
                    } 
                    if(z[i]['onaccount']=="Shipper's Account"){
                        l['shipperchargesList'].push(z[i])
                    }
                    if(z[i]['onaccount']=="Consignee's Account"){
                        l['consigneechargesList'].push(z[i])
                    }
                }
            }
            l['orginalchargesList'] = z
            let k = new QuoteCalcV2(l).recalc()
            l['quoteValue'] = k.quoteValue
            l['quoteValueUSD'] = k.quoteValueUSD
            if(k.quoteValue!=0){
                let t1 = Utils.getTotal(originallist)+Utils.getTotal(originalrebatelist)+Utils.getTotal(originalpkblist)
                let t2 = Utils.getTotal(l['orginalchargesList'])
                let t3 = Utils.getTotal(l['pkb'])
                let t4 = Utils.getTotal(l['rebate'])
                t2 = t2+t4+t3
                conditions.map(e=>{
                    if(e.reductionPercentage!=undefined){
                        if(((t2 / t1) * 100) < (100 - e.reductionPercentage)){
                            if(lobj[JSON.stringify(e)]==undefined){
                            lobj[JSON.stringify(e)] = 1
                            limits.push(e)
                            }
                            let e2 = `Charge list total: ${t1.toFixed(2)} (100.00%), Revised list total: ${t2.toFixed(2)} (${((t2 / t1) * 100).toFixed(2)}%) is less than the allowed limit (${(100 - e.reductionPercentage).toFixed(2)}%).`
                            if(eobj[JSON.stringify(e2)]==undefined){
                            eobj[JSON.stringify(e2)] = 1
                            err.push(e2)
                            }
                        }
                    }
                    if(e.reductionValue!=undefined){
                        let v = configStore.getExchangeRate(e.reductionValueCurrency)
                        let t5 = t1/v
                        let t6 = t2/v
                        let t7 = t5-e.reductionValue
                        if(t7>t6){
                            let e2 = `Charge list total: ${Utils.N(t5,e.reductionValueCurrency)} (100.00%), Revised list total: ${Utils.N(t6,e.reductionValueCurrency)} (${((t2 / t1) * 100).toFixed(2)}%) is less than the allowed limit (${Utils.N(t7,e.reductionValueCurrency)}%).`
                            if(lobj[JSON.stringify(e)]==undefined){
                                lobj[JSON.stringify(e)] = 1
                                limits.push(e)
                            }
                            if(eobj[JSON.stringify(e2)]==undefined){
                                eobj[JSON.stringify(e2)] = 1
                                err.push(e2)
                            }
                        }
                        // l['orginalchargesList'].map(e1=>{
                        //     if(e1['currency']==e.reductionValueCurrency){
                        //         if(e1['total']<e.reductionValue){
                        //             if(lobj[JSON.stringify(e)]==undefined){
                        //             lobj[JSON.stringify(e)] = 1
                        //             limits.push(e)
                        //             }
                        //             let e2 = `${e1['chargeDescription']}, Currency: ${e.reductionValueCurrency}, Totol: ${e1['total']} is less than the allowed limit ${e.reductionValue}`
                        //             if(eobj[JSON.stringify(e2)]==undefined){
                        //             eobj[JSON.stringify(e2)] = 1
                        //             err.push(e2)
                        //             }
                        //         }
                        //     }
                        // })
                    }
                })
                if(err.length==0 && t1!=t2 && conditions.length==0){
                    err.push(`Charge list total: ${t1.toFixed(2)} (100.00%), Revised list total: ${t2.toFixed(2)} (${((t2 / t1) * 100).toFixed(2)}%).`)
                }
                editapprovalStore.editquote['totalnewrevisedcharge'] = t2
                editapprovalStore.editquote['limitdetails'] = limits
                editapprovalStore.editquote['limiterrors'] = err
                editapprovalStore.editquote['mrg_chargesList'] = l['orginalchargesList']
                editapprovalStore.editquote['pkb'] = l['pkb']
                editapprovalStore.editquote['rebate'] = l['rebate']
                editapprovalStore.editquote['quoteData']['quoteValue'] = l['pkb']
                editapprovalStore.editquote['quoteData']['quoteValueUSD'] = l['rebate']
                editapprovalStore.editquote['quoteData']['aiChargeHistory'] = getAiHistory("quoteApproval")
                setActionmodal(true)
            }
        }
    }
    
    useEffect(()=>{
        if(editapprovalStore.quote?.conditionsPayload){
            const callback = (data) =>{
                    setConditions(data.data)
                    setShow1(true)
                    loader.hide()
                }
                loader.show()
                Api.apiGetconditionslist(editapprovalStore.quote.conditionsPayload,callback)
        }
    },[])


    useEffect(()=>{
        if(!show && editapprovalStore.quote?.quoteData && JSON.stringify(editapprovalStore.quote?.quoteData)==JSON.stringify(contractsStore.current)){
        if(JSON.stringify(cargoStore.cargoList)!=JSON.stringify(editapprovalStore.quote.cargoList)){
            cargoStore.cargoList = JSON.parse(JSON.stringify(editapprovalStore.quote.cargoList))
        }
        cargoStore.calculateCargoTotals()
        let c = []
        let k = []
        if(editapprovalStore.quote.chargesList!=undefined){
            c = editapprovalStore.quote.chargesList
        }
        if(editapprovalStore.quote.mrg_chargesList!=undefined){
            k = editapprovalStore.quote.mrg_chargesList
        }
        if(editapprovalStore.quote.nomrg_rebate!=undefined){
            if(JSON.stringify(originalrebatelist)!=JSON.stringify(editapprovalStore.quote.nomrg_rebate)){
                setValue('originallistrebate',JSON.parse(JSON.stringify(editapprovalStore.quote.nomrg_rebate)))
                setOriginalrebatelist(JSON.parse(JSON.stringify(editapprovalStore.quote.nomrg_rebate)))
            }
        }
        if(editapprovalStore.quote.nomrg_pkb!=undefined){
            if(JSON.stringify(originalpkblist)!=JSON.stringify(editapprovalStore.quote.nomrg_pkb)){
                setValue('originallistpkb',JSON.parse(JSON.stringify(editapprovalStore.quote.nomrg_pkb)))
                setOriginalrebatelist(JSON.parse(JSON.stringify(editapprovalStore.quote.nomrg_pkb)))
            }
        }
        chargesBookingValidationStore.isNew = true
        setValue('initialLength',k.length)
        setValue('list',JSON.parse(JSON.stringify(k)))
            let type = editapprovalStore.quote.quoteData.shipmentType
            let scope = editapprovalStore.quote.quoteData.shipmentScope
            const data1 = chargesData1[type.toLowerCase()+scope.toLowerCase()];
            if(editapprovalStore.quote.rebate==undefined || editapprovalStore.quote.rebate.length==0){
                setValue('rebate',JSON.parse(JSON.stringify(data1.rebate)))
            }else{
                setValue('rebate',JSON.parse(JSON.stringify(editapprovalStore.quote.rebate)))
            }
            if(editapprovalStore.quote.pkb==undefined || editapprovalStore.quote.pkb.length==0){
                setValue('pkb',JSON.parse(JSON.stringify(data1.pkb)))
            }else{
                setValue('pkb',JSON.parse(JSON.stringify(editapprovalStore.quote.pkb)))
            }
            setValue('originallistlist',c)
            setOriginallist(c)
        setShow(true)
        }
    },[JSON.stringify(editapprovalStore.quote),JSON.stringify(contractsStore.current)])


    const getlcv = (ob,key)=>{
        if(ob!=undefined){
            if(ob[key]!=undefined){
                return ob[key]
            }
        }
        return "-"
    }


    return (<>{ show &&<>
    {
                            actionmodal && <div className='modal is-active'>
                            <div className="modal-background"></div>
                            <div className="modal-card">
                                <section className="modal-card-body" >
                                    <button className="delete" style={{ float: 'right' }} onClick={() => { setActionmodal(false) }}></button>
                                     <p>
                                        Are you sure you want to approve this?
                                     </p>
                                     <p>
                                        Please confirm to proceed.
                                     </p>
                                     <textarea class={"textarea is-info"} value={remarks}   placeholder="Enter your remarks. (Optional)" rows={5} onChange={(e) => {
                                setRemarks(e.target.value)
                            }}></textarea>
                                     
                                     <hr />
                        <div style={{ display: 'flex', justifyContent: 'flex-start', gap: 10 }}>
                                <div className="control">
                                    <button class="button is-danger" onClick={() => {
                                        setActionmodal(false)
                                    }}>
                                        Cancel
                                    </button>
                                </div>
                                <div className="control">
                                    <button className="button"
                                     style={{backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON, color: "#fff"}}
                                        onClick={async (e) => {
                                            loader.show()
                                            console.log(editapprovalStore.editquote)
                                            const callback = (d)=>{
                                                loader.hide()
                                                setOpenChargeModel(false)
                                                setActionmodal(false)
                                                configStore.setModalMessage("Approved successfully.")
                                                AgmodalStore.pageVisible = false;
                                                AgmodalStore.apiCall = true;
                                            }
                                            editapprovalStore.editquote.remarks = remarks
                                            Api.setQuoteupdateapprove(editapprovalStore.editquote,callback)
                                        }}>
                                        Confirm
                                    </button>
                                </div>
                            </div>
                                </section>
                            </div>
                        </div>
                        }
    {
                        req.err.length>0 && <>
                        <Card>
                                    <Headspan color="#00000" fontSize= "14px" fontWeight="900" data="Charge Limit"/>
                                    {req.limits.length>0 && <div className="table-container">
                                    <table style={{border:"none", width:"100%"}}>
                    <thead>
                        <tr style={{ fontWeight:"900",border:"solid 0.5px #D4D4D4"}}>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Origin Country</th>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Destination Country</th>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>POL</th>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>POD</th>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Rate Type</th>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Reduction Percentage</th>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Reduction Value</th>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Reduction Value Currency</th>
                        </tr>
                        </thead>
                        <tbody>
                            {
                                req.limits.map(e=>{
                                    return <tr style={{border:"solid 0.5px #D4D4D4"}}>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"originCountry")}</td>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"destinationCountry")}</td>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"pol")}</td>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"pod")}</td>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"rateType")}</td>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"reductionPercentage")}</td>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"reductionValue")}</td>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"reductionValueCurrency")}</td>
                            </tr>
                                })
                            }
                        </tbody>
                        </table>
                        
                        </div>}

                        <div className="table-container">
                                    <table style={{border:"none", width:"100%"}}>
                    
                        <tbody>
                            {
                                req.err.map(e=>{
                                    return <tr style={{border:"solid 0.5px #D4D4D4"}}>
                                <td style={{color:"#555555", padding:"10px"}}>{e}</td>
                            </tr>
                                })
                            }
                        </tbody>
                        </table>
                        
                        </div>

                                    </Card>
                                    <hr />
                        </>
                    }

   <FormProvider {...charges}>             
<div class="columns is-multiline">
  <div class="column is-4">
    <LCLChargesCompFrom form={charges} oyahide={true} listkey={"originallistlist"} contract={editapprovalStore.quote?.quoteData} isDisable={true} heading={"Charge Details"}/>
    {originalrebatelist.length>0 && <LCLChargesCompFrom form={charges} listkey={"originallistrebate"} hide={true} isDisable={true} contract={editapprovalStore.quote?.quoteData}/>}
    {originalpkblist.length>0 && <LCLChargesCompFrom form={charges} listkey={"originalpkbrebate"} hide={true} isDisable={true} contract={editapprovalStore.quote?.quoteData}/>}
  </div>
  <div class="column is-8">

    <LCLChargesCompFrom form={charges} listkey={"list"} contract={editapprovalStore.quote?.quoteData} heading={"Revised Details"} aiHistory={{ scope: "quoteApproval" }} />
        {RoleUtils.isUserAuthorized(PERMISSIONS_NEW.QUOTATIONS_APPROVAL.REBATE) && <><hr /><LCLChargesCompFrom form={charges} listkey={"rebate"} hide={true} contract={editapprovalStore.quote?.quoteData}/></>}
        {RoleUtils.isUserAuthorized(PERMISSIONS_NEW.QUOTATIONS_APPROVAL.PKB) && <><hr /><LCLChargesCompFrom form={charges} listkey={"pkb"} hide={true} contract={editapprovalStore.quote?.quoteData}/></>}

</div>  
</div>   
</FormProvider>
    <div className="columns is-vcentered is-multiline">
<div className="column is-12" style={{textAlign:"right"}}>
<div
                    className="field is-grouped"
                    style={{ display: "flex", justifyContent: "flex-start" }}
                  >
                    {RoleUtils.isUserAuthorized(PERMISSIONS_NEW.QUOTATIONS_APPROVAL.APPROVE_REJECT) && <div className="control">
                      <button
                        className="button"
                        style={{
                          backgroundColor:
                            process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                          color: "#fff",
                        }}
                        onClick={async (e) => {
                          save()
                        }}
                      >
                        Approve
                      </button>
                    </div>}
                    <div className="control">
                      <button
                        class="button is-danger"
                        onClick={() => {
                          setOpenChargeModel(false)
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
</div></div>
           
            
    </>}</>)
}


